import { useState } from 'react'
import { toast } from 'sonner'
import { apiV2, ApiV2Error } from '@/lib/api-v2-client'

/**
 * Opens the Paddle customer portal in a new tab. The tab opens during the click so
 * Safari and Firefox do not block it as a popup. Shared by the billing tab and the
 * past-due banner (OpenSpec 138).
 */
export function useBillingPortal() {
  const [loading, setLoading] = useState(false)

  async function open() {
    setLoading(true)
    const tab = window.open('', '_blank')
    try {
      const result = await apiV2.createPortalSession()
      if (tab) tab.location.href = result.portal_url
      else window.location.assign(result.portal_url)
    } catch (err) {
      tab?.close()
      toast.error(err instanceof ApiV2Error ? err.message : 'Failed to open billing portal')
    } finally {
      setLoading(false)
    }
  }

  return { open, loading }
}
